import React from 'react';
import BookReaderScreen from './BookReaderScreen';

/**
 * Legacy IntroductionScreen - now delegates to unified BookReaderScreen
 * Kept for backwards compatibility with existing navigation
 * 
 * This thin wrapper allows existing navigation code to work without changes.
 * BookReaderScreen will fetch the full book data (intro + insights) using
 * the book object or bookId from params.
 */

const IntroductionScreen: React.FC = () => {
  return <BookReaderScreen />;
};

export default IntroductionScreen;
